import React from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDateInput,
  MimaDropdown,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../../components";
import { amountFormatter } from "../../../utils/utils";

const VerifyP2PSellerPayment = ({
  loading,
  onSubmit,
  closeModal,
  statusData,
  validationSchema,
  singleItem,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb="7" width={38}>
        Verify P2P Payment by {singleItem.seller.username} (Seller)
      </MimaText>
      <Formik
        initialValues={{
          amount: singleItem?.sellerDebitValue.amount,
          sellerPaymentDateTime: "",
          sellerStatus: "",
          note: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaText mb={2} labelTitle="Confirm Seller Paid">
              {amountFormatter(singleItem.sellerDebitValue.currencyCode).format(
                singleItem?.sellerDebitValue.amount
              )}
            </MimaText>
            <MimaText mb={2} labelTitle="Confirm Reference Code">
              {singleItem?.referenceCode}
            </MimaText>
            <MimaInput
              name="amount"
              labelTitle="Amount"
              type="number"
              placeholder="Enter amount"
              value={values.amount}
              onChange={handleChange("amount")}
              onBlur={handleBlur("amount")}
              error={errors.amount}
              touched={touched.amount}
            />

            <MimaDateInput
              labelTitle="Seller Payment Date/Time"
              name="sellerPaymentDateTime"
              // variant="message"
              value={values.sellerPaymentDateTime}
              onChange={(text) => {
                setFieldValue("sellerPaymentDateTime", text);
              }}
              onBlur={handleBlur}
              touched={touched.sellerPaymentDateTime}
              error={errors.sellerPaymentDateTime}
              showTimeSelect
              mt={2}
              width={38}
            />
            <MimaDropdown
              labelTitle="Status"
              placeholder="Select status"
              name="sellerStatus"
              data={statusData}
              value={values.sellerStatus}
              id="sellerStatus"
              onChange={(data) => {
                setFieldValue("sellerStatus", data.key);
              }}
              error={errors.sellerStatus}
              touched={touched.sellerStatus}
            />

            <MimaTextArea
              labelTitle="Note"
              variant="message"
              placeholder="Enter Note"
              name="note"
              value={values.note}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.note}
              touched={touched.note}
              mb={2}
            />
            <MimaButton
              title="Continue"
              width={38}
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default VerifyP2PSellerPayment;
